module.exports = __webpack_public_path__ + "static/registr-c8f4bae6d4d4832aeb359deed3f5c598.png";